import InstagramIcon from '@mui/icons-material/Instagram';
import XIcon from '@mui/icons-material/X';
import { Typography } from "@mui/material";
import FacebookFilled from "../../assets/images/icons/FacebookFilled.svg";

function LoginFooter() {
  return (
    <div className="footer-outer-wrapper">
        <div className="footer-wrapper">
            <div className="container">
                <div className="footer">
                   
                    <div className="row d-flex justify-content-center justify-content-lg-between align-items-center g-2">
                        
                        <div className="col-auto  me-1 me-lg-5 me-xl-1 px-0">
                            <div className="footer-right-part d-flex align-items-center flex-wrap justify-content-center">
                                <span className="text-nowrap me-2 ">
                                    <Typography variant="body2" sx={{ color: '#737376', fontSize: '14px', fontWeight: "600" }} component="a" href="https://whitedogllc.com/" target="_blank" rel="noopener noreferrer">
                                    Home
                                    </Typography>
                                </span>
                                <span className="text-nowrap mx-2 ">
                                    <Typography variant="body2" sx={{ color: '#737376', fontSize: '14px', fontWeight: "600" }} component="a" href="https://whitedogllc.com/about" target="_blank" rel="noopener noreferrer">
                                    About
                                    </Typography>
                                </span>
                                <span className="text-nowrap mx-2 ">
                                    <Typography variant="body2" sx={{ color: '#737376', fontSize: '14px', fontWeight: "600" }} component="a" href="https://whitedogllc.com/storage" target="_blank" rel="noopener noreferrer">
                                    Storage
                                    </Typography>
                                </span>
                                <span className="text-nowrap mx-2 ">
                                    <Typography variant="body2" sx={{ color: '#737376', fontSize: '14px', fontWeight: "600" }} component="a" href="https://whitedogllc.com/aged-spirits" target="_blank" rel="noopener noreferrer">
                                    Aged Spirits
                                    </Typography>
                                </span>
                                <span className="text-nowrap mx-2 ">
                                    <Typography variant="body2" sx={{ color: '#737376', fontSize: '14px', fontWeight: "600" }} component="a" href="https://whitedogllc.com/new-fill" target="_blank" rel="noopener noreferrer">
                                    New Fill
                                    </Typography>
                                </span>
                                <span className="text-nowrap mx-2 ">
                                    <Typography variant="body2" sx={{ color: '#737376', fontSize: '14px', fontWeight: "600" }} component="a" href="https://whitedogllc.com/contact" target="_blank" rel="noopener noreferrer">
                                    Contact
                                    </Typography>
                                </span>
                            </div>
                        </div>
                        <div className="col-auto  ms-1 ms-lg-5 ms-xl-1 px-0">
                        <div className="footer-right-part d-flex align-items-center justify-content-center">
                                <div className="me-2">
                                    <Typography variant="body2" sx={{ color: '#B7A577', fontSize: '14px', fontWeight: 700 }}>
                                        FOLLOW US
                                    </Typography>
                                </div>
                                <div className="d-flex align-items-center gap-2">
                                    <a href="https://www.facebook.com/wdtsllc" target="_blank" rel="noopener noreferrer"><span style={{backgroundColor: '#71828A', borderRadius:"50%", padding:"2px", height:"35px", width:"35px", display:"flex", alignItems:"center", justifyContent:"center"}}> <img src={FacebookFilled} alt="footerLogo" height={25}/></span></a>
                                    <span style={{backgroundColor: '#71828A', borderRadius:"50%", padding:"2px", height:"35px", width:"35px", display:"flex", alignItems:"center", justifyContent:"center"}}> <XIcon sx={{ color:"#FDFCFA", marginInline: '4px' }} /></span>
                                    <a href="https://www.instagram.com/whitedogtradingandstorage/" target="_blank" rel="noopener noreferrer"><span style={{backgroundColor: '#71828A', borderRadius:"50%", padding:"2px", height:"35px", width:"35px", display:"flex", alignItems:"center", justifyContent:"center"}}> <InstagramIcon sx={{ color:"#FDFCFA", marginInline: '4px' }} /></span></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 px-0">
                            
                            <span className="d-flex justify-content-center align-items-center flex-wrap text-white gap-1 gap-md-3">
                                <Typography variant="body2" sx={{ color: '#737376', fontSize: '14px', fontWeight: "400" }}>
                                © White Dog Trading Post. All rights reserved. 
                                </Typography>
                                <div className='d-flex align-items-center flex-wrap gap-3'>
                                <Typography variant="body2" sx={{ color: '#737376', fontSize: '14px', fontWeight: "400" }}>
                                Terms
                                </Typography>
                                <Typography variant="body2" sx={{ color: '#737376', fontSize: '14px', fontWeight: "400" }}>
                                Privacy
                                </Typography>
                                <Typography variant="body2" sx={{ color: '#737376', fontSize: '14px', fontWeight: "400" }}>
                                Cookie Policy
                                </Typography>
                                <Typography variant="body2" sx={{ color: '#737376', fontSize: '14px', fontWeight: "400" }}>
                                Accessibility
                                </Typography>
                                </div>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
  )
}

export default LoginFooter